import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../base/Header";
import { useSelector } from "react-redux";
import { Alert, Box, Button, Card, CardContent, Checkbox, Chip, CircularProgress, FormControl, InputAdornment, InputLabel, LinearProgress, ListItemText, MenuItem, OutlinedInput, Select, SelectChangeEvent, Snackbar, SnackbarCloseReason, Typography, styled } from "@mui/material";
import { ReactComponent as VectorLogo } from "../../static/svgs/vector.svg";
import { ReactComponent as FilterIcon } from "../../static/svgs/filter.svg"
import { ReactComponent as CloseIcon } from "../../static/svgs/closefiltericon.svg"
import { ReactComponent as BigCommentIcon } from "../../static/svgs/commentBigIcon.svg"
import { ReactComponent as NoArtifactIcon } from "../../static/svgs/NoArtifactIcon.svg"
import { ReactComponent as NoCommentIcon } from "../../static/svgs/NoCommentIcon.svg"
import { ReactComponent as BigArtifactIcon } from "../../static/svgs/artifactBigIcon.svg"
import { ReactComponent as RedDot } from "../../static/svgs/RedDot.svg"
import { ReactComponent as InfoSnackIcon } from "../../static/svgs/infoSnackIcon.svg"


import educatorService from "services/educatorService";
import { useDispatch } from "react-redux";
import { setAssociatedSkillsRedux, AssociatedSkillsCredit, AssociatedSkillsArea, AssociatedSkillsData, AssociatedSkillsState } from "redux/slices/associatedSkills/associatedSkillsSlice";
import { format } from "date-fns";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getColorByTitle } from "utils/componentUtils";
import { lazy, Suspense } from "react";
// Assets
import SkillsPage from "pages/base/SkillsPage";
import NewSkillsPage from "pages/base/NewSkillsPage";
const BatchReset = lazy(() => import("./BatchReset"));
const TableComponent = lazy(() => import("components/TableComponent"));

// ...existing code...

interface GetAllCount {
  data: string
}


const EducatorBase = () => {
  const user = useSelector((state: any) => state.account);
  const navigate = useNavigate();
  const intersectionElementRef = useRef(null);
  const [associatedSkills, setAssociatedSkills] = useState<AssociatedSkillsState | null>(null);
  const dispatch = useDispatch();
  const [learnerOption, setLeanerOption] = useState<string>('');
  const [visibleKeys, setVisibleKeys] = useState<string[]>([]);
  const [widgetData, setWidgetData] = useState<any | null>(null);
  const [drop, setDrop] = useState([]);
  // const [activitiesCount, setactivitiesCount] = useState<any>();
  // const [artifactsCount, setartifactsCount] = useState<any>();
  const [resetPage, setresetPage] = useState(1)
  const [open, setOpen] = useState<boolean>(false)
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const today = new Date();
  // const [loadingStatus, setLoadingStatus] =
  //   useState<"idle" | "pending" | "error" | "success">("pending");
  // const [loadingStatus2, setLoadingStatus2] =
  //   useState<"idle" | "pending" | "error" | "success">("pending");
  const [openSnack, setOpenSnack] = useState(false);
  const [tableLoadingStatus, setTableLoadingStatus] = useState<"idle" | "pending" | "error" | "success">("pending");

  const formattedDate = format(today, "EEEE, MMMM do");
  const filterOptions = ["Unread Comments", "New Artifacts"];
  const isPlanningLibrary = useSelector((state: any) => state?.account?.isPlanningLibrary ?? false);
  const canResetModules = useSelector((state: any) => state?.account?.canResetModules ?? false);
  const skillsRedux = useSelector((state: any) => state.associatedSkills?.data);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            navigate(`/educator/#${entry.target.id}`);
          }
        });
      },
      { rootMargin: "0px 0px -100%", root: intersectionElementRef.current }
    );

    Array.from(document.querySelectorAll("div[id]"))
      .filter((section) => section.id !== "root")
      .forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, [navigate]);

  useEffect(() => {
    const DropValue = localStorage.getItem(`dropDownValue_${user?.id}`);
  
    const load = async () => {
      await fetchLearnerGroups(); 
  
      if (DropValue) {
        setLeanerOption(DropValue);
      } else {
        setLeanerOption(""); 
      }
    };
    load();
  }, []);

  const fetchAssociatedSkills =
    async (): Promise<AssociatedSkillsState | null> => {
      try {
        if (skillsRedux?.id && Array.isArray(skillsRedux.areas) && skillsRedux.areas.length > 0) {
          setAssociatedSkills(skillsRedux as AssociatedSkillsState);
          return skillsRedux as AssociatedSkillsState;
        }

        const [skillsResponse, competencyResponse] = await Promise.all([
          educatorService.fetchAssociatedSkills(user.schoolId,isPlanningLibrary),
          educatorService.getCompetencyModel(user.schoolId),
        ])
        
        if (skillsResponse && competencyResponse) {
          const associatedSkillsState: AssociatedSkillsState = {
            ...skillsResponse,
            visibleLevels: competencyResponse.visible_levels || 3,
          };

          setAssociatedSkills(associatedSkillsState as AssociatedSkillsState);
          // Map AssociatedSkillsState to AssociatedSkillsData before dispatch

          const requiredProperties = ["id", "schoolId", "areas", "visibleLevels"] as const;
          if (requiredProperties.every(prop => prop in associatedSkillsState)) {
            dispatch(setAssociatedSkillsRedux({
              id: (associatedSkillsState as any).id,
              schoolId: (associatedSkillsState as any).schoolId,
              areas: (associatedSkillsState as any).areas,
              visibleLevels: (associatedSkillsState as any).visibleLevels,
              ...((skillsResponse as any).schoolModel ? { schoolModel: (skillsResponse as any).schoolModel } : {})
            }));
          }
          return associatedSkillsState; // Return the typed data for further use
        }

        return null;
      } catch (error) {
        console.error("Error fetching associated skills:", error);
        return null;
      }
    };

  // const getAllActivitiesCounts = async () => {
  //   setLoadingStatus("pending")
  //   const data = await educatorService.getAllActivitiesCounts(user.schoolId)
  //   {
  //     if (data) {
  //       setactivitiesCount(data)
  //       setLoadingStatus("success")
  //       setLoadingStatus2("pending")
  //       let artifacts = await educatorService.educatorArtifacts(data.studentIds)
  //       setartifactsCount(artifacts)
  //       setLoadingStatus2("success")

  //     }
  //   }
  // }
  const handleBulkLearnerIds = (ids: any) => 
  { 
    setWidgetData({...ids}) 
  };

  useEffect(() => {
    fetchAssociatedSkills();
  }, [user.schoolId, isPlanningLibrary])

  // useEffect(() => {
  //   !isPlanningLibrary &&
  //     getAllActivitiesCounts();
  // }, [])

  // useEffect(() => {
  //   if (!isPlanningLibrary) {
  //     if (artifactsCount && artifactsCount.artifactCount !== 0) {
  //       const itemsToShow = isPlanningLibrary ? 7 : 3;
  //       const keys = Object.keys(artifactsCount).slice(0, itemsToShow);
  //       setVisibleKeys(keys);
  //     } else {
  //       setVisibleKeys([]);
  //     }
  //   }
  // }, [artifactsCount, user.schoolId]);

  const fetchLearnerGroups = async () => {
    try {
      const data = await educatorService.getLearnerGroups(user.schoolId);
      if (data) {
        setDrop(data);
      }
    } catch (error) {
      console.error("Error fetching learner groups:", error);
    }
  };

  const handleChangeFilter = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectedFilters(typeof value === "string" ? value.split(",") : value);
  };

  const handleBoxClick = (val: string) => {
    setSelectedFilters((prev) => {
      if (prev.includes(val)) {
        setOpenSnack(true);
        return prev;
      } else {
        return [...prev, val];
      }
    });
  };


  const handleDelete = (filterToDelete: string) => {
    setSelectedFilters((prev) =>
      prev.filter((filter) => filter !== filterToDelete)
    );
  };
  const handleChange = (event: SelectChangeEvent) => {
    setLeanerOption(event.target.value)
    localStorage.setItem(`dropDownValue_${user?.id}`, event.target.value)
  }
  interface CustomLinearProgressProps {
    item?: string;
  }
  // const activityData = [
  //   { title: 'Repurposing', progress: 0 },
  //   { title: 'Storytelling', progress: 0 },
  //   { title: 'Puzzle Solving', progress: 0 },
  //   { title: "Collaborative Problem Solving", progress: 0 },
  //   { title: "Critical Thinking", progress: 0 },
  //   { title: "Oral Communication", progress: 0 },
  //   { title: "Written Communication", progress: 0 },
  //   { title: "Career Interest Profiler", progress: 0 },
  // ];
  // const artifactData = [
  //   { title: 'Collaboration', progress: 0 },
  //   { title: 'Communication', progress: 0 },
  //   { title: 'Critical Thinking', progress: 0 },
  // ];
  // const artifactDataNC = [
  //   { title: 'Adaptability', progress: 0 },
  //   { title: 'Collaboration', progress: 0 },
  //   { title: 'Communication', progress: 0 },
  //   { title: 'Critical Thinking', progress: 0 },
  //   { title: 'Empathy', progress: 0 },
  //   { title: "Learner's Mindset", progress: 0 },
  //   { title: 'Personal Responsibility', progress: 0 },

  // ];
  // const visibleArtifactData = isPlanningLibrary ? artifactDataNC : artifactData;

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  return (
    <Box
      flexWrap="nowrap"
      overflow="hidden"
      height="100%"
      sx={{ backgroundColor: "rgba(254, 253, 251, 1)", p: 0 }}
    >
      <Box flex={1} height="100%" display="flex" flexDirection="column">
        <Header />

        <Box
          ref={intersectionElementRef}
          sx={{
            overflow: "auto",
            height: "100%",
            position: "relative",
            "&::-webkit-scrollbar": {
              display: "none", // For Chrome, Safari, and Edge
            },
            "-ms-overflow-style": "none", // For Internet Explorer and Edge
            "scrollbar-width": "none",
          }}
        >
          <Box px={0} pt={5} id="home" sx={{ minHeight: "100vh" }}>
            <>
              <VectorLogo
                style={{
                  fill: "rgba(20, 96, 214, 1)",
                  position: "absolute",
                  right: 0,
                  top: 0,
                  width: "100%",
                  backgroundColor: "rgba(0, 82, 210, 1)",
                  height: "140px",
                }}
              />
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  mt: "10px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "16px",
                    lineHeight: "22.4px",
                    fontWeight: 400,
                    color: "white",
                  }}
                >
                  {formattedDate}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "40px",
                    lineHeight: "44px",
                    fontWeight: 600,
                    color: "white",
                  }}
                >
                  {`Welcome back, ${user.firstName ? user.firstName : ''} ${user.lastName ? user.lastName : ''}!`}
                </Typography>
                <Snackbar
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  open={openSnack}
                  autoHideDuration={2000}
                  onClose={()=>setOpenSnack(false)}
                  sx={{width:'330px', marginTop:'50px'}}
                >
                  <Alert icon={<InfoSnackIcon/>}   
                    sx={{
                      width: "100%",
                      backgroundColor: "#E5EEFA",   
                      color: "#455459",              
                    }}
                  >
                  Selection has already been applied
                  </Alert>
                  </Snackbar>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', px: 7, marginTop: '50px' }}>
                <Box sx={{ justifyContent: "left" }}>
                  {widgetData &&<><Typography sx={{ fontSize: '22px', fontWeight: '600', fontFamily: 'Open Sans', justifyContent: "left" }}>
                    Here’s what needs your attention:
                  </Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: '500', fontFamily: 'Open Sans', justifyContent: "left", color: '#455459', marginTop: '2px'}}>
                    Last updated: {widgetData.lastUpdatedAt && format(new Date(widgetData.lastUpdatedAt * 1000), "MM/dd/yyyy h:mm a") }
                  </Typography></>}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '15px' }}>
                  {widgetData&&widgetData.totalComments<=0 ? <Card sx={{
                    width: 274, height: 84, marginTop: '20px', justifyContent: 'center', 
                    borderRadius: '12px', border: '1px solid #E6E6E6',
                  }}>
                    <CardContent sx={{ paddingTop: '12px', paddingLeft: '24px' }}>
                      <Box sx={{ display: 'flex', alignContent: 'flex-start' }}>
                        <NoCommentIcon sx={{ verticalAlign: 'top' }} />
                        <Box sx={{ ml: '20px' }}>
                          <Typography sx={{ fontSize: '16px', fontWeight: '600', fontFamily: 'Open Sans', lineHeight: '0.7' }}>Comments</Typography>
                          <Typography sx={{ fontSize: '12px', fontWeight: '500', fontFamily: 'Open Sans', mt: '4px', color: '#455459' }} >You’re all caught up!</Typography>
                          {/* <Typography sx={{ fontSize: '12px', fontWeight: '700', fontFamily: 'Open Sans', mt: '4px', color: 'rgba(0, 82, 210, 1)', cursor: 'pointer' }} >View</Typography> */}
                        </Box>
                      </Box>
                    </CardContent>
                  </Card> :
                  widgetData && <Card sx={{
                    width: 274, height: 84, marginTop: '20px', justifyContent: 'center',
                     borderRadius: '12px', border: '1px solid #E6E6E6',
                    '&:hover': { backgroundColor: 'rgba(255, 249, 246, 1)' }
                  }}>
                      <CardContent sx={{ paddingTop: '12px', paddingLeft: '24px' }}>
                        <Box sx={{ display: 'flex', alignContent: 'flex-start' }}>
                          <BigCommentIcon sx={{ verticalAlign: 'top' }} />
                          <Box sx={{ ml: '20px' }}>
                            <Typography sx={{ fontSize: '16px', fontWeight: '600', fontFamily: 'Open Sans', lineHeight: '0.7' }}>Comments</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '500', fontFamily: 'Open Sans', mt: '4px', color: learnerOption ? '#A7ADB1' : 'inherit' }} >{`left by ${widgetData.totalComments} learners`}</Typography>
                            <Typography onClick={() => tableLoadingStatus === 'success' && !learnerOption && handleBoxClick('Unread Comments')} sx={{
                              fontSize: '12px', fontWeight: '700',
                              fontFamily: 'Open Sans', mt: '4px', color: (tableLoadingStatus === 'success' && !learnerOption) ? 'rgba(0, 82, 210, 1)' : 'rgba(0, 82, 210, 0.4)',
                              cursor: (tableLoadingStatus === 'success' && !learnerOption) ? 'pointer' : 'default',
                              pointerEvents: (tableLoadingStatus === 'success' && !learnerOption) ? 'auto' : 'none'
                            }}>View</Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>}
                  {widgetData&&widgetData.totalNeedsReview<=0 ? <Card sx={{
                    width: 274, height: 84, marginTop: '20px', justifyContent: 'center', 
                    borderRadius: '12px', border: '1px solid #E6E6E6',
                  }}>
                    <CardContent sx={{ paddingTop: '12px', paddingLeft: '24px' }}>
                      <Box sx={{ display: 'flex', alignContent: 'flex-start', gap: '3px' }}>
                        {/* <RedDot /> */}
                        <NoArtifactIcon sx={{ verticalAlign: 'top', marginLeft: '3px' }} />
                        <Box sx={{ ml: '20px' }}>
                          <Typography sx={{ fontSize: '16px', fontWeight: '600', fontFamily: 'Open Sans', lineHeight: '0.7' }}>New Artifacts</Typography>
                          <Typography sx={{ fontSize: '12px', fontWeight: '500', fontFamily: 'Open Sans', mt: '4px', color: '#455459' }} >0 students uploaded</Typography>
                          {/* <Typography sx={{ fontSize: '12px', fontWeight: '700', fontFamily: 'Open Sans', mt: '4px', color: 'rgba(0, 82, 210, 1)', cursor: 'pointer' }} >View</Typography> */}
                        </Box>
                      </Box>
                    </CardContent>
                  </Card> : widgetData && <Card sx={{
                    width: 274, height: 84, marginTop: '20px', justifyContent: 'center', borderRadius: '12px', border: '1px solid #E6E6E6',
                    '&:hover': { backgroundColor: 'rgba(246, 253, 255, 1)' }
                  }}>
                    <CardContent sx={{ paddingTop: '12px', paddingLeft: '24px' }}>
                      <Box sx={{ display: 'flex', alignContent: 'flex-start', gap: '3px' }}>
                        {/* <RedDot /> */}
                        <BigArtifactIcon sx={{ verticalAlign: 'top', marginLeft: '3px' }} />
                        <Box sx={{ ml: '20px' }}>
                          <Typography sx={{ fontSize: '16px', fontWeight: '600', fontFamily: 'Open Sans', lineHeight: '0.7' }}>New Artifacts</Typography>
                          <Typography sx={{ fontSize: '12px', fontWeight: '500', fontFamily: 'Open Sans', mt: '4px', color: learnerOption ? '#A7ADB1' : 'inherit' }} >{`uploaded by ${widgetData.totalNeedsReview} learners`}</Typography>
                          <Typography onClick={() => tableLoadingStatus === 'success' && !learnerOption && handleBoxClick('New Artifacts')} sx={{
                            fontSize: '12px', fontWeight: '700',
                            fontFamily: 'Open Sans', mt: '4px', color: (tableLoadingStatus === 'success' && !learnerOption) ? 'rgba(0, 82, 210, 1)' : 'rgba(0, 82, 210, 0.4)',
                            cursor: (tableLoadingStatus === 'success' && !learnerOption) ? 'pointer' : 'default',
                            pointerEvents: (tableLoadingStatus === 'success' && !learnerOption) ? 'auto' : 'none'
                          }} >View</Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>}
                </Box>
              </Box>
              {/* {!isPlanningLibrary && <Box sx={{ backgroundColor: "rgba(242, 246, 253, 1)", display: 'flex', flexDirection: 'row', paddingBottom: '25px', px: 5 }}>
                <Box sx={{ justifyContent: "left", width: '330px', padding: '15px' }}>
                  <Typography sx={{ fontSize: '22px', fontWeight: '600', fontFamily: 'Open Sans', marginTop: '90px', justifyContent: "left", pr: '20px' }}>
                    Learner Data
                  </Typography>
                  <Typography sx={{ fontSize: '16px', fontWeight: '400', fontFamily: 'Open Sans', justifyContent: "left", pr: '20px' }}>
                    The information presented here is an aggregate of the data from all of your assigned Learners. This data is updated once an hour.
                  </Typography>
                </Box>

                <Card sx={{
                  width: 276, maxHeight: 340, marginTop: '90px', pl: '5px', justifyContent: 'center', borderRadius: '10px',
                  '&.MuiCardContent-root': {
                    padding: '16px 8px 16px 16px',
                  },
                }}>
                  <CardContent sx={{
                    '&.MuiCardContent-root': {
                      padding: '16px 8px 16px 16px',
                    }
                  }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '700', fontFamily: 'Open Sans' }} gutterBottom>
                      Activity Completion
                    </Typography>
                    {loadingStatus === "pending" && (
                      <Box
                        sx={{
                          position: 'absolute',
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          zIndex: 10,
                          width: window.innerWidth == 1024 ? 200 : 250,
                          height: 295,
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    )}
                    <Box sx={{
                      overflowY: 'auto',
                      maxHeight: 250,
                      pr: 3,
                      '&::-webkit-scrollbar': {
                        width: '4px',
                      },
                      '&::-webkit-scrollbar-track': {
                        background: 'transparent',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(131, 141, 144, 0.3)',
                        borderRadius: '8px',
                      },

                      // Removes arrows in some browsers
                      '&::-webkit-scrollbar-button': {
                        display: 'none',
                        height: 0,
                        width: 0,
                      },
                    }}>
                      {(activitiesCount != null && Object?.keys(activitiesCount?.activityCompletion).length > 0) ? Object?.keys(activitiesCount?.activityCompletion)?.map((item: any, index: any) => (
                        <Box key={index}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '24px', mb: '3px', fontFamily: 'Open Sans' }}>
                            <Typography sx={{ fontWeight: '600', fontSize: '13px', fontFamily: 'Open Sans' }} noWrap>{PascalCase(item)}</Typography>
                            <Typography sx={{
                              fontWeight: '600', fontSize: '13px', color: 'rgba(65, 77, 85, 1)', fontFamily: 'Open Sans',
                              whiteSpace: 'nowrap',
                              overflow: 'visible',
                              textOverflow: 'unset'
                            }} >
                              {activitiesCount.activityCompletion[item]} <span style={{ fontWeight: '400', fontSize: '13px' }}>of</span> {activitiesCount.studentIds.length}
                            </Typography>
                          </Box>
                          <CustomLinearProgress variant="determinate" value={(activitiesCount.activityCompletion[item] / activitiesCount.studentCount) * 100} />
                        </Box>
                      )) : activityData.map((item, index) => (
                        <Box key={index}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '24px', mb: '3px', fontFamily: 'Open Sans' }}>
                            <Typography sx={{ fontWeight: '600', fontSize: '13px', fontFamily: 'Open Sans' }} noWrap>{PascalCase(item.title)}</Typography>
                            <Typography sx={{
                              fontWeight: '700', fontSize: '13px', color: 'rgba(65, 77, 85, 1)', fontFamily: 'Open Sans',
                              whiteSpace: 'nowrap',
                              overflow: 'visible',
                              textOverflow: 'unset',
                            }} >
                              {item.progress} <span style={{ fontWeight: '400', fontSize: '13px' }}>of</span> {activitiesCount?.studentIds.length ?? 0}
                            </Typography>
                          </Box>
                          <CustomLinearProgress variant="determinate" value={item.progress} />
                        </Box>))}
                    </Box>
                  </CardContent>
                </Card>
                <Card sx={{
                  width: 276, maxHeight: 340, marginTop: '90px', px: '5px', justifyContent: 'center', marginLeft: '24px', borderRadius: '10px',
                  '&.MuiCardContent-root': {
                    padding: '16px 8px 16px 16px',
                  },
                }}>
                  <CardContent sx={{
                    '&.MuiCardContent-root': {
                      padding: '16px 8px 16px 16px',
                    }
                  }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '700', fontFamily: 'Open Sans' }} gutterBottom>
                      Artifacts <span style={{ fontWeight: '400', fontFamily: 'Open Sans' }}>per Skill</span>
                    </Typography>
                    {loadingStatus2 === "pending" && (
                      <Box
                        sx={{
                          position: 'absolute',
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          zIndex: 10,
                          width: window.innerWidth == 1024 ? 200 : 250,              // or any specific width
                          height: 290,             // or any specific height
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    )}
                    <Box sx={{
                      overflowY: 'auto',
                      maxHeight: 250,
                      pr: 3,
                      '&::-webkit-scrollbar': {
                        width: '4px',
                      },
                      '&::-webkit-scrollbar-track': {
                        background: 'transparent',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(131, 141, 144, 0.3)',
                        borderRadius: '8px',
                      },

                      // Removes arrows in some browsers
                      '&::-webkit-scrollbar-button': {
                        display: 'none',
                        height: 0,
                        width: 0,
                      },
                    }}>
                      {visibleKeys.length > 0 ? visibleKeys.map((item: any, index: any, x: any) => (
                        <Box key={index}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '24px', mb: '3px', fontFamily: 'Open Sans' }}>
                            <Typography sx={{ fontWeight: '600', fontSize: '13px', fontFamily: 'Open Sans' }}>{item.replace("CriticalThinking", "Critical Thinking")}</Typography>
                            <Typography sx={{ fontWeight: '600', fontSize: '13px', color: 'rgba(65, 77, 85, 1)', fontFamily: 'Open Sans' }} >
                              {artifactsCount[item]} <span style={{ fontWeight: '400', fontSize: '13px' }}>artifacts</span>
                            </Typography>
                          </Box>
                          <CustomLinearProgress variant="determinate" value={(artifactsCount[item] / artifactsCount?.artifactCount) * 100} item={item} />
                        </Box>
                      )) : visibleArtifactData.map((item, index) => (
                        <Box key={index}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '24px', mb: '3px', fontFamily: 'Open Sans' }}>
                            <Typography sx={{ fontWeight: '600', fontSize: '13px', fontFamily: 'Open Sans' }}>{item.title}</Typography>
                            <Typography sx={{ fontWeight: '700', fontSize: '13px', color: 'rgba(65, 77, 85, 1)', fontFamily: 'Open Sans' }} >
                              {item.progress} <span style={{ fontWeight: '400', fontSize: '13px' }}>artifacts</span>
                            </Typography>
                          </Box>
                          <CustomLinearProgress variant="determinate" value={item.progress} item={item.title} />
                        </Box>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
                <Card sx={{ width: 276, height: 340, marginTop: '90px', px: '5px', justifyContent: 'center', marginLeft: '24px', borderRadius: '10px' }}>
                  <CardContent>
                    <Box sx={{ marginTop: '50%', marginBottom: '50%', justifyContent: 'center', px: '10px' }}>
                      <Typography sx={{ fontSize: '16px', fontWeight: '700', fontFamily: 'Open Sans', textAlign: 'center' }} gutterBottom>
                        No Data Yet
                      </Typography>
                      <Typography sx={{ fontSize: '13px', fontWeight: '400', fontFamily: 'Open Sans', textAlign: 'center' }} gutterBottom>
                        Subskill development will display here when available
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Box>} */}
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  mt: '26px',
                  px: 5
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "row", gap: '10px' }}>
                  {canResetModules && <Button sx={{ alignItems: 'right', justifyContent: 'right', color: 'black', fontWeight: '600', fontSize: '16px', fontFamily: 'Open Sans' }} onClick={() => setOpen(true)}>Reset Modules</Button>}
                  <Suspense fallback={null}>
                    {canResetModules && <BatchReset resetPage={resetPage} open={open} onClose={() => setOpen(false)} />}
                  </Suspense>
                  <FormControl variant="outlined" sx={{ m: 1, width: 240 }}>
                    <Select
                      value={learnerOption}
                      onChange={handleChange}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                      IconComponent={ExpandMoreIcon}
                      defaultValue=""
                      sx={{ padding: '0px', fontWeight: '600', fontFamily: 'Open Sans', borderRadius: '8px', fontSize: '16px', height: 40, "& .MuiSelect-select": { paddingY: '5px' } }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            "& .MuiMenuItem-root.Mui-selected": {
                            },
                            "& .MuiMenuItem-root:hover": {
                              color: "rgba(0, 82, 210, 1)",
                              fontWeight: '600',

                            },
                            '& .MuiMenuItem-root:hover::after': {
                              content: '""',
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              bottom: 0,
                              width: '4px',
                              backgroundColor: "rgba(0, 82, 210, 1)",
                            },
                          }
                        }
                      }}
                    >
                      <MenuItem sx={{ fontFamily: 'Open Sans', fontWeight: '400', fontSize: '16px' }} value="">
                        <span>My Learners</span>
                      </MenuItem>
                      {drop?.map((menuItem: any) =>
                        <MenuItem sx={{ fontFamily: 'Open Sans', fontWeight: '400', fontSize: '16px' }} value={menuItem?.id}>
                          {menuItem?.name}
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ m: 1, minWidth: 104 }}>
                    <Select
                      labelId="filter-label"
                      multiple
                      value={selectedFilters}
                      onChange={handleChangeFilter}
                      displayEmpty
                      input={
                        <OutlinedInput
                          startAdornment={
                            <InputAdornment position="start">
                              <FilterIcon sx={{ height: 24, width: 12 }} />
                            </InputAdornment>
                          }
                        />
                      }
                      sx={{ fontWeight: '400', fontFamily: 'Open Sans', 
                      fontSize: '14px', width: 104, height: 40,
                       borderRadius: '8px', "& .MuiSelect-select": { paddingY: '5px', ml: '5px' } }}
                      IconComponent={ExpandMoreIcon}
                      renderValue={() => {
                        return <span style={{ color: "rgba(7, 27, 34, 1)" }}>Filter</span>; // placeholder
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            // Ensure the menu’s list uses left alignment
                            "& .MuiList-root": {
                              textAlign: "left"
                            },
                            // Make sure items align from left, not centered
                            "& .MuiMenuItem-root": {
                              display: "flex",
                              alignItems: "flex",
                              justifyContent: "flex-start",
                              textAlign: "left",
                              gap: 0
                            },
                            // Keep checkbox at the left with spacing
                            "& .MuiCheckbox-root": {
                              marginRight: 2
                            }
                          }
                        },
                        MenuListProps: {
                          sx: {
                            textAlign: "left"
                          }
                        }
                      }}
                    >
                      
                      {filterOptions.map((option) => (
                        <MenuItem key={option} value={option} >
                        <Checkbox checked={selectedFilters.indexOf(option) > -1} />
                        <ListItemText primary={option} sx={{ textAlign: "left" }} />
                      </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* Selected filters beside dropdown */}
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3, m: 1, alignItems: 'center' }}>
                    {selectedFilters.map((filter) => (
                      <Chip
                        key={filter}
                        label={filter}
                        onDelete={() => handleDelete(filter)}
                        sx={[{ p: 2, borderRadius: '4px' }, filter?.includes('Comm') ? { backgroundColor: "rgba(255, 225, 212, 1)" } : { backgroundColor: "rgba(229, 238, 250, 1)" }]}
                        deleteIcon={<CloseIcon style={{ marginLeft: '1px', marginTop: '1px' }} />}
                      />
                    ))}
                  </Box>
                </Box>
                <Suspense fallback={<div>Loading table...</div>}>
                  <TableComponent setresetPage={setresetPage} learnerOption={learnerOption} 
                  onBulkLearnersReady={handleBulkLearnerIds} selectedFilters={selectedFilters} 
                  widgetData={widgetData} onLoadingStatusChange={setTableLoadingStatus} />
                </Suspense>
              </Box>
            </>
          </Box>
          <Box id="skills" mt={5} px={5}>
            <Box sx={{ backgroundColor: "white", minHeight: "100vh" }}>
              <NewSkillsPage skillsData={associatedSkills} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default EducatorBase;
